/**
 * DevExtreme (events/core/event_registrator_callbacks.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var MemorizedCallbacks = require("../../core/memorized_callbacks");
module.exports = new MemorizedCallbacks;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/events/core/event_registrator_callbacks.js
// module id = 538
// module chunks = 0